export default function Privacy() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f0fdf4 0%, #ffffff 60%)",
      padding: "48px 24px",
      fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
      color: "#111827"
    }}>
      <div style={{ maxWidth: 780, margin: "0 auto" }} data-testid="privacy-page" dir="ltr">
        <a href="/" style={{ color: "#047857", textDecoration: "none", fontWeight: 600 }}>← SocialHub</a>

        <h1 style={{ fontSize: 40, fontWeight: 800, marginTop: 24, marginBottom: 8 }}>
          Privacy Policy
        </h1>
        <p style={{ color: "#6b7280", marginBottom: 32 }}>Last updated: February 2026</p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24 }}>1. Information We Collect</h2>
        <p style={{ lineHeight: 1.7 }}>
          When you connect Meta channels (Facebook, Instagram, WhatsApp), we receive from the Meta Graph API:
          your name, email, page IDs, page access tokens, Instagram business account IDs, and message content
          routed through our inbox. We do NOT collect your Facebook friends list, personal photos, or timeline posts.
        </p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24 }}>2. How We Use It</h2>
        <p style={{ lineHeight: 1.7 }}>
          Data is used exclusively to (a) route incoming customer messages to your SocialHub inbox,
          (b) send outbound replies on your behalf, (c) generate AI auto-replies when enabled by you,
          and (d) provide analytics on message volume in your dashboard.
        </p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24 }}>3. Sharing</h2>
        <p style={{ lineHeight: 1.7 }}>
          We never sell your data. We share message content only with our sub-processors necessary
          to deliver the service (Meta, OpenAI when AI reply is enabled, our hosting provider).
        </p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24 }}>4. Data Retention & Deletion</h2>
        <p style={{ lineHeight: 1.7 }}>
          You can disconnect any channel at any time from the Channels page. To fully delete your account
          and all data, follow the steps on our{" "}
          <a href="/data-deletion" style={{ color: "#047857" }}>Data Deletion</a> page.
        </p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24 }}>5. Security</h2>
        <p style={{ lineHeight: 1.7 }}>
          Tokens are stored encrypted at rest. All API traffic uses HTTPS. Access is limited to authorized
          personnel on a need-to-know basis.
        </p>

        <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24 }}>6. Contact</h2>
        <p style={{ lineHeight: 1.7 }}>
          Privacy questions? Email <a href="mailto:support@letsm.io" style={{ color: "#047857" }}>support@letsm.io</a>.
        </p>
      </div>
    </div>
  );
}
